export default function newsletter() {
//* --- Variabili e funzioni per controllare il form iscrizione Newsletter
    var isOkToGoNL;
    window.initialize_nlcb = function () {
        $('#nlform').submit(function (event) {
            isOkToGoNL = true;
            $('.thom-form__error').html("");
            $('#nlform').find('.field-error').removeClass("field-error");
            var checkboxes = document.querySelectorAll(`[data-required='${1}']`);
            if (checkboxes.length) {
                $.each(checkboxes, function (key, obj) {
                    if (!obj.checked) {
                        $('.thom-form__error').html("Please accept all required flags.");
                        $('#' + obj.id).parent().addClass('field-error');
                        isOkToGoNL = false;
                    }
                })
            }
            if (isOkToGoNL !== true) {
                event.preventDefault();
            }
        });
    }
}